import React from 'react'
import { Box, Button, Tooltip, useColorMode, useColorModeValue, useBreakpointValue } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { MoonIcon, SunIcon } from '@chakra-ui/icons'

const LightsToggle = () => {
    const { colorMode, toggleColorMode } = useColorMode()
    const { t } = useTranslation()

    const responsiveColor = useBreakpointValue({
        base: useColorModeValue('brand.blue', 'brand.blue'),
        md: useColorModeValue('brand.blue', 'brand.blue'),
        lg: useColorModeValue('brand.white', 'brand.white')
    });

    const responsiveHoverColor = useBreakpointValue({
        base: useColorModeValue('brand.yellow', 'brand.yellow'),
        md: useColorModeValue('brand.yellow', 'brand.yellow'),
        lg: useColorModeValue('brand.yellow', 'brand.yellow'),
    });

    return (
        <Box mx={2}>
            <Tooltip label={colorMode === 'light' ? t('lights-off') : t('lights-on')}>
                <Button
                    onClick={toggleColorMode}
                    bg={'transparent'}
                    px={0}
                    minW={8}
                    ml={1}
                    _hover={{
                        textDecoration: 'none',
                        cursor: 'pointer',
                        bg: 'transparent',
                        color: responsiveHoverColor,
                    }}
                    color={responsiveColor}
                >
                    {colorMode === 'dark' && <SunIcon fontSize={'xl'} />}
                    {colorMode === 'light' && <MoonIcon fontSize={'xl'}  />}
                </Button>
            </Tooltip>
        </Box>
    )
}

export default LightsToggle
